import AsyncStorage from "@react-native-async-storage/async-storage";
import * as actions from "./actions";

const config = {
  key: "state",
  blacklist: [
    "customer",
    "loading",
    "navigation",
    "response",
    "survey",
    "network",
  ],
};

export const clearState = (chunks = []) => (dispatch, getState) => {
  if (!chunks.length) {
    return AsyncStorage.removeItem(config.key, () =>
      dispatch(actions.clearState(chunks)),
    );
  }

  const state = { ...getState() };
  chunks.forEach(chunk => (state[chunk] = undefined));
  return AsyncStorage.setItem(config.key, JSON.stringify(state), () =>
    dispatch(actions.clearState(chunks)),
  );
};

export const rehydrateState = () => (dispatch, getState) => {
  AsyncStorage.getItem(config.key).then(rawState => {
    const savedState = JSON.parse(rawState) || undefined;
    const state = { ...getState(), ...savedState };
    dispatch(actions.rehydrateState(state));
  });
};

export const persistState = () => (dispatch, getState) => {
  const state = { ...getState() };
  config.blacklist.forEach(chunk => (state[chunk] = undefined));
  AsyncStorage.setItem(config.key, JSON.stringify(state), () =>
    dispatch(actions.persistState(state)),
  );
};
